import { Toaster } from 'react-hot-toast';
import { ThemeProvider } from '@/contexts/ThemeProvider';
import { GlobalErrorBoundary } from '@/components/error-boundary';
import { SanityDataProvider } from '@/sanity/SanityDataProvider';
import { AppRouter } from '@/routes/AppRouter';
import { WhatsAppButton } from '@/components/ui/WhatsAppButton';

/**
 * R4 - Root App component with all providers
 * Wraps application with Error Boundary, Theme Provider, Toast notifications,
 * and global WhatsApp floating action button
 */
export function App() {
  return (
    <GlobalErrorBoundary>
      <SanityDataProvider>
        <ThemeProvider defaultTheme="system" storageKey="ui-theme">
          <AppRouter />
          <WhatsAppButton />
          <Toaster
            position="top-right"
            toastOptions={{
              duration: 4000,
              style: {
                background: 'hsl(var(--background))',
                color: 'hsl(var(--foreground))',
                border: '1px solid hsl(var(--border))'
              }
            }}
          />
        </ThemeProvider>
      </SanityDataProvider>
    </GlobalErrorBoundary>
  );
}
